import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { useState, useEffect } from "react";
import { buildWhatsAppOrderUrl } from "@/lib/contact";

const navItems = [
  { to: "/", label: "Laman Utama" },
  { to: "/katalog", label: "Katalog" },
  { to: "/tentang", label: "Tentang Kami" },
  { to: "/hubungi", label: "Hubungi" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 glass border-b border-[rgba(28,28,28,0.08)]" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo-link">
            <div className="w-10 h-10 rounded-xl bg-[#1C1C1C] text-[#FAF9F6] flex items-center justify-center font-heading font-bold text-lg">
              S
            </div>
            <div className="leading-tight">
              <div className="font-heading font-bold text-[15px] sm:text-base tracking-tight">Sangkar Murah</div>
              <div className="label-eyebrow text-[#4A4A4A]">Enterprise</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-link-${n.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors ${
                    isActive ? "text-[#E07A5F]" : "text-[#1C1C1C] hover:text-[#E07A5F]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={buildWhatsAppOrderUrl()}
              target="_blank"
              rel="noreferrer"
              data-testid="navbar-whatsapp-btn"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#25D366] text-white hover:bg-[#1EBE57] transition-all duration-300 font-semibold text-sm shadow-[0_6px_20px_rgba(37,211,102,0.25)]"
            >
              <MessageCircle className="w-4 h-4" />
              <span className="hidden sm:inline">Tempah</span>
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden p-2.5 rounded-xl border border-[rgba(28,28,28,0.1)] text-[#1C1C1C]"
              data-testid="mobile-menu-toggle"
              aria-label="Menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-5 flex flex-col gap-1" data-testid="mobile-menu">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mobile-nav-link-${n.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-sm font-medium ${
                    isActive ? "bg-[#F4F1EA] text-[#E07A5F]" : "text-[#1C1C1C] hover:bg-[#F4F1EA]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};
